import { TFunction } from '@getpopsure/i18n-react';
import { getTitleMapping } from 'models/insurances/types/mapping';
import { Policy } from 'models/policies';

import { GenericPolicyTypeSchema } from '../PolicySingle.models';

export const getPolicyTitle = (t: TFunction, policy?: Policy): string => {
  if (!policy) return '';

  if (policy.type !== 'GENERIC') {
    return getTitleMapping(t)[policy.type];
  }

  /**
   * Return the custom title for generic policies if it exists.
   * Otherwise, use getTitleMapping to get the title based on the policy type.
   */
  let title: string | undefined;

  if (policy.attributes.genericPolicyTypeData) {
    const policyConfig = GenericPolicyTypeSchema.safeParse(
      policy.attributes.genericPolicyTypeData
    );
    title = policyConfig.success
      ? policyConfig.data.header?.title
      : getTitleMapping(t)[policy.type];
  }

  return title || getTitleMapping(t)[policy.type];
};
